<template>
    <v-container>
		<div v-if="type === 'routines'">
			<div>
        <v-skeleton-loader
            class="mt-0 mb-2 kimsa-elevation"
            type="list-item-avatar-three-line"
        ></v-skeleton-loader>
				<v-skeleton-loader
					type="list-item"
          class="my-0 py-0"
				></v-skeleton-loader>
				<v-skeleton-loader
            v-for="i in 2" :key="i"
            class="mt-0 mb-2 kimsa-elevation"
            type="list-item-avatar-three-line"
				></v-skeleton-loader>
			</div>
		</div>
		<div v-if="type === 'dialogRoutine'">
			<v-container style="margin-top: 70px">
				<v-skeleton-loader
					type="image, table-row@2, list-item, table-row"
					:types="{
						'table-row': 'table-cell@3',
					}"
				></v-skeleton-loader>
			</v-container>
		</div>
		<div v-if="type === 'routineDetail'">
			<v-skeleton-loader
				type="list-item, table-row, divider, list-item@2, divider, list-item-avatar-three-line@2, divider, list-item@2, divider, list-item-avatar-three-line@2"
				:types="{
					'table-row': 'table-cell@3',
				}"
			></v-skeleton-loader>
		</div>
		<div v-if="type === 'routineCard'">
			<v-row>
				<v-col cols="6" v-for="i in 4" :key="i">
					<v-skeleton-loader
						transition="fade"
						height="100"
						class="kimsa-elevation"
						type="card"
					></v-skeleton-loader>
				</v-col>
			</v-row>
		</div>
		<div v-if="type === 'exerciseDetail'">
			<v-skeleton-loader
				type="text, list-item, paragraph, image, table-heading@4"
			></v-skeleton-loader>
		</div>
	</v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
	props: {
		type: {
			type: String,
			default: '',
		}
	},
    data() {
		return {
			//
		}
	},
	computed: {
		...mapState(['typeSkeleton'])
	},
}
</script>